
import Block from './components/Block';
import Navbar from './components/Navbar';
import styles from "./css.module.css";
import { Slider } from "./components/Slider";
import { Carousel } from './components/Craousel';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
// import Flighthome from './components/Flighthome';
// import { Bookingcss } from './components/Bookingcss';
// import { Icondiv } from './components/Icondiv';
// import { Fromto } from './components/Fromto';
// import { Fare } from './components/Fare';
// import { Wrap } from './components/Wrap';
import Home from './Pages/Home/Home';
import "font-awesome/css/font-awesome.min.css";
import "./components/homepage.css";
import AllRoutes from './components/AllRoutes';
import FlightSearch from './components/Flights/FlightSearch';
import Spinner from './components/Spinner';
import TrainList from './components/Train/TrainList';
import LoginPage from "../src/Forms/LoginPage"
import TrainSerch from './components/TrainSerch';
import TrainRoute from "./components/TrainRoute";
import Footer from './Footer/Footer';
function App() {
  const [isLoading, setIsLoading] = useState(true);
  

  useEffect(() => {
    // Simulating data fetching delay
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);
  return (
    <BrowserRouter>
      <Navbar />
      {isLoading ? (
        <Spinner />):(
      <Routes>
        <Route path="/" element={<AllRoutes />} />
        <Route path="/FlightSearch" element={<FlightSearch />} />
        <Route path="/TrainList" element={<TrainList />} />
        <Route path="/TrainSearch" element={<TrainRoute/>} />
        <Route path="/hotel" element={<Home/>} />
        <Route path="/Login" element={<LoginPage/>}/>
      </Routes>)}
      <Footer />
    </BrowserRouter>




  );
}

export default App;
